import api from "../utils/api";
import { LOGOUT } from "./types";

export const listDestinations = () => async (dispatch) => {
    try {
        const res = await api.get("/hooks/destinations");
        return res.data?.items || [];
    } catch (err) {
        dispatch({ type: LOGOUT });
        return [];
    }
};

export const saveDestination = (destination) => async (dispatch) => {
    try {
        const res = await api.post("/hooks/destinations", destination);
        return res.data || {};
    } catch (err) {
        dispatch({ type: LOGOUT });
        return {};
    }
};

export const deleteDestination = (uuid) => async (dispatch) => {
    try {
        const res = await api.delete(`/hooks/destinations/i/${uuid}`);
        return res.data || {};
    } catch (err) {
        dispatch({ type: LOGOUT });
        return {};
    }
};
